import { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './my-profile.module.css';
import NavHeader from '../shared/Nav-Header';

const RecruiterProfile = () => {
    const [profile, setProfile] = useState({
        name: '',
        emailOrPhone: '',
        companyName: '',
        position: '',
        profileImage: '',
    });

    const [isEditing, setIsEditing] = useState(false);
    const [notification, setNotification] = useState('');
    const [uploading, setUploading] = useState(false);

    // Fetch profile data
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get('/api/recruiter/profile/get-profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setProfile(response.data.recruiterPro);
            } catch (error) {
                const errorMessage = error.response?.data?.message || 'Error fetching profile:';
                console.error(errorMessage);
                setNotification('Failed to fetch profile.');
            }
        };

        fetchProfile();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile({ ...profile, [name]: value });
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'ml_default'); // Replace with your Cloudinary upload preset
        setUploading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/api/upload/upload-all', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            const url = response.data.url;

            setProfile({ ...profile, profileImage: url });
            setUploading(false);
        } catch (error) {
            console.error('Error uploading image:', error);
            setNotification('Failed to upload image.');
        }
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem('token');
            await axios.put('/api/recruiter/profile/update-profile', profile, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setNotification('Profile updated successfully.');
            setIsEditing(false);
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Error updating profile:';
            console.error(errorMessage);
            setNotification('Failed to update profile.');
            setUploading(false);
        }
    };

    return (
        <>
            <NavHeader />
            <div className={styles.profileContainer}>
                <h1 className={styles.profileTitle}>Recruiter Profile</h1>
                {notification && <p className={styles.notification}>{notification}</p>}
                <div className={styles.profileCard}>
                    <img
                        title={profile.name}
                        src={profile.profileImage ? profile.profileImage.replace('/upload/', '/upload/w_480,h_500,c_fill/') : 'https://via.placeholder.com/150'}
                        alt="Profile"
                        className={styles.profileImage}
                    />
                    {isEditing && (
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}
                            className={styles.fileInput}
                        />
                    )}
                    <div className={styles.profileDetails}>
                        {isEditing ? (
                            <>
                                <label htmlFor="name">Name:</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={profile.name}
                                    onChange={handleChange}
                                    className={styles.inputField}
                                />
                                <label htmlFor="emailOrPhone">Email or Phone:</label>
                                <input
                                    type="emailOrPhone"
                                    name="emailOrPhone"
                                    value={profile.emailOrPhone}
                                    onChange={handleChange}
                                    className={styles.inputField}
                                />
                                <label htmlFor="companyName">Company:</label>
                                <input
                                    type="text"
                                    name="companyName"
                                    value={profile.companyName}
                                    onChange={handleChange}
                                    className={styles.inputField}
                                />
                                <label htmlFor="position">Position:</label>
                                <input
                                    type="text"
                                    name="position"
                                    value={profile.position}
                                    onChange={handleChange}
                                    className={styles.inputField}
                                />
                            </>
                        ) : (
                            <>
                                <h2>{profile.name}</h2>
                                <p><strong>EmailOrPhone:</strong> {profile.emailOrPhone}</p>
                                <p><strong>Company:</strong> {profile.companyName}</p>
                                <p><strong>Position:</strong> {profile.position}</p>
                            </>
                        )}
                    </div>
                    <div className={styles.profileActions}>
                        {isEditing ? (
                            <>
                                <button onClick={handleSave} disabled={uploading} className={styles.saveButton}>
                                    Save
                                </button>
                                <button
                                    onClick={() => setIsEditing(false)}
                                    className={styles.cancelButton}
                                >
                                    Cancel
                                </button>
                            </>
                        ) : (
                            <button
                                onClick={() => setIsEditing(true)}
                                className={styles.editButton}
                            >
                                Edit Profile
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecruiterProfile;